import { render, staticRenderFns } from "./sale-btn.vue?vue&type=template&id=623682f9&scoped=true&"
import script from "./sale-btn.vue?vue&type=script&lang=js&"
export * from "./sale-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623682f9",
  null
  
)

export default component.exports